<tec-modal
    [title]="'TWO_FACTOR.TITLE' | translate"
    [isVisible]="true"
    [buttonPrimaryLabel]="showSms() && !resendingSms() ? ('TWO_FACTOR.BUTTON_VERIFY' | translate) : ''"
    (closeEvent)="onModalClose($event)"
>
    @if (apiError()) {
        <tec-alert type="message" [msg]="apiError()!" [status]="'error'" hiddenCloseButton />
    }

    @if (convertedToSms()) {
        <tec-alert
            type="message"
            [msg]="'TWO_FACTOR.FALLBACK_SMS_INFO' | translate"
            hiddenCloseButton
            icon="icon-info"
        />
    }

    @if (showSms()) {
        <div class="two-factor-modal__section">
            <p class="two-factor-modal__subtitle">{{ 'TWO_FACTOR.SMS_OTP_SUBTITLE' | translate }}</p>
            @if (resendingSms()) {
                <tec-tile
                    class="two-factor-modal__tile"
                    [type]="'loading'"
                    [title]="'TWO_FACTOR.RESEND_LOADING' | translate"
                />
            } @else {
                <tec-tile class="two-factor-modal__tile" [formGroup]="otpForm">
                    <div class="two-factor-modal__tile-body">
                        <tec-info-group class="two-factor-modal__countdown">
                            <tec-icon name="icon-clock" size="xs" />
                            <span>{{ countdown() }}</span>
                        </tec-info-group>
                        <tec-code-input
                            class="two-factor-modal__code"
                            formControlName="otp"
                            [errorMsg]="reactiveFormService.hasMsgError(otpForm.get('otp'))"
                        />
                        <div class="two-factor-modal__resend">
                            @if (canResendSms()) {
                                <span>{{ 'CONNECTIONS.WORK_LIFE.SMS_NOT_RECEIVED' | translate }}</span>
                                <tec-link (click)="resendSms()">{{ 'CONNECTIONS.WORK_LIFE.SMS_RESEND' | translate }}</tec-link>
                            } @else {
                                <span>{{ 'TWO_FACTOR.RESEND_LIMIT_REACHED' | translate }}</span>
                            }
                        </div>
                    </div>
                </tec-tile>
            }
        </div>
    }

    @if (showWhatsapp()) {
        <div class="two-factor-modal__section two-factor-modal__section--whatsapp">
            <p class="two-factor-modal__subtitle">{{ 'TWO_FACTOR.WHATSAPP_SUBTITLE' | translate }}</p>
            <div class="two-factor-modal__whatsapp-icon-wrapper">
                <img
                    class="two-factor-modal__whatsapp-tag"
                    src="assets/images/two-factor-whatsapp-tag.png"
                    [alt]="'TWO_FACTOR.WHATSAPP_ARIA' | translate"
                    loading="lazy"
                />
            </div>
        </div>
    }
</tec-modal>
